<template>
  <div class="background_container_mobile">
    <div class="page_header_login">
      <img src="assets/img/box-double.png" style="width:50%" id="double_png" />
      <img src="assets/img/box-dots.png" style="width:25%;" />
      <img
        src="assets/img/box-round-blu.png"
        style="transform: rotateY(180deg);width:25%;"
      />
    </div>
    <div class="login_form_mobile">
      <div
        style="height: 100px; width: 183px;margin:auto;flex:24;justify-content: center;"
        :style="accessStatus == request ? 'flex:10;' : ''"
      >
        <img
          src="assets/img/gk-logo-vert-1.svg"
          style="height:12vh;max-height:100px;"
        />
      </div>
      <div style="flex:5;" :style="accessStatus == request ? 'flex:2;' : ''">
        <div
          style="
          box-sizing: border-box;
          height: 1px;
          width: 201px;
          border: 1px solid #979797;
          border-radius: 0.5px;
          background-color: #d8d8d8;
        "
        ></div>
      </div>
      <p
        style="color: #333333;
        font-family: Aleo;
        font-size: 4vh;
        font-style: italic;
        letter-spacing: 1.83px;
        line-height: 40px;
        text-align: center;
        flex:13;"
        id="welcome_text"
        :style="accessStatus == request ? 'flex:4;' : ''"
      >
        {{ showRequestAccess ? accessStatus : "Welcome back!" }}
      </p>
      <div
        class="form-group"
        v-if="showError"
        style="    width: 279px;
                    height: 34px;"
      >
        <p
          class="register-question"
          style="    color: rgb(201, 63, 38);
                        font-family: Montserrat;
                    font-weight: 500;
                    text-align: center;
                    font-size: 12px;
                    letter-spacing: 0.04px;
                    line-height: 15px;"
        >
          Either the email address or the password <br />
          entered is incorrect.
        </p>
      </div>
      <p
        style="
          color: #333333;
          font-family: Montserrat;
          font-size: 12px;
          letter-spacing: 0.67px;
          line-height: 15px;
          text-align: center;
        "
        :style="accessStatus == request ? 'margin-bottom:27px;' : ''"
        v-if="showRequestAccess"
      >
        {{ getRequestDescription() }}
      </p>
      <div
        class="form-group"
        v-if="
          !showRequestAccess || (showRequestAccess && accessStatus == request)
        "
        style="margin-right:28px;margin-left:28px;flex:10;"
        :style="accessStatus == request ? 'flex:2;' : ''"
      >
        <input
          name="email"
          type="email"
          id="email"
          class="form-input form-control input_placeholder"
          placeholder="E-mail address"
          style="
            box-sizing: border-box;
            height: 46.3px;
            width: 100%;
            border: 1px solid #979797;
            background-color: #ffffff;
            
          "
        />
      </div>
      <div
        class="form-group"
        v-if="!showRequestAccess"
        style="margin-right:28px;margin-left:28px;flex:9;"
      >
        <input
          name="pass"
          id="pass"
          class="form-input form-control input_placeholder"
          placeholder="Password"
          type="password"
          style="box-sizing: border-box;
      height: 46.3px;
      width: 100%;
      border: 1px solid #979797;
      background-color: #ffffff;"
        />
      </div>
      <p
        style="
          color: #1e4c42;
          font-family: Montserrat;
          font-size: 12px;
          letter-spacing: 0.04px;
          line-height: 15px;
          text-align: center;
          cursor: pointer;
          height: 24px;
        "
        @click="backToLogin()"
        v-if="
          showRequestAccess &&
            (accessStatus == requestInProgress || accessStatus == requestFailed)
        "
      >
        Return to login
      </p>
      <div
        class="form-group"
        style="margin: auto;margin-left:28px;margin-right:28px;align-items:center;flex:6;padding: 2px;"
        v-if="!showRequestAccess"
      >
        <label style="display: inline-flex;margin-bottom:auto;margin-top:auto;">
          <input
            name="remember"
            type="checkbox"
            class="form-check"
            value="on"
            style="height: 13px; width: 13px;"
          />
        </label>
        <span
          style="
            color: #000000;
            font-family: Montserrat;
            font-size: 12px;
            letter-spacing: 0.04px;
            line-height: 15px;
            margin: -4px 0px 0px 4px;margin-bottom:auto;margin-top:auto;
          "
          >Stay signed in</span
        >
        <span
          style="
            color: #1e4c42;
            font-family: Montserrat;
            font-size: 12px;
            letter-spacing: 0.04px;
            line-height: 15px;
            float: right;
            cursor: pointer;margin-left: auto;
          "
          href="mailto:GlobalGoalKeeper@123goecom.com"
          @click="reqAccessCalled()"
          >Request access</span
        >
      </div>
      <div
        style="
          width: 157.5px;
          height: 45px;
          text-align: center;
          margin: auto;
          background-color: #ffbf3f;
          cursor: pointer;
          border-radius: 26.5px;
          display: flex;
          justify-content: center;
          align-items: center;
          flex:7;
          max-height:45px;
        "
        v-if="
          !showRequestAccess || (showRequestAccess && accessStatus == request)
        "
        @click="
          showRequestAccess && accessStatus == request
            ? backToLogin()
            : signIn()
        "
      >
        <span
          style="
            color: #333333;
            font-family: Montserrat;
            font-size: 14px;
            font-weight:600;
            letter-spacing: 0.05px;
            line-height: 30px;
            height:45px;
            display: flex;
            justify-content: center;
            align-items: center;
          "
        >
          {{
            showRequestAccess && accessStatus == request ? "Submit" : "Sign in"
          }}
        </span>
      </div>
      <p
        style="
          color: #333333;
          font-family: Aleo;
          font-size: 15px;
          font-weight:400;
          letter-spacing: 0.33px;
          line-height: 18px;
          text-align: center;
          margin-bottom: auto;
          flex:11;
        "
        v-if="!showRequestAccess"
      >
        Powered by data, improved by humans.
      </p>
      <div style="flex:11;"></div>
    </div>
    <div class="login_footer">
      <object
        data="assets/img/go-logo-horz.svg"
        style="height: 36px;width: 175px;"
      ></object>
    </div>
  </div>
</template>

<script>
import * as AmazonCognitoIdentity from "amazon-cognito-identity-js";
export default {
  data() {
    return {
      email: "",
      pass: "",
      showError: false,
      errorMessage: "",
      showRequestAccess: false,
      accessStatus: "",
      request: "Request access",
      requestInProgress: "Access requested",
      requestFailed: "Were sorry…",
    };
  },
  methods: {
    backToLogin() {
      this.accessStatus = "";
      this.showRequestAccess = false;
    },
    reqAccessCalled() {
      this.accessStatus = this.request;
      this.showRequestAccess = true;
      this.showError = false;
    },
    getRequestDescription() {
      if (this.accessStatus == this.request) {
        return "Please enter your Global Overview email address.";
      } else if (this.accessStatus == this.requestInProgress) {
        return "Please allow up to 72 hours for us to get back to you.";
      } else if (this.accessStatus == this.requestFailed) {
        return "Goalkeeper is currently only available for Global Overview and its partners.";
      }
    },
    signIn() {
      let vm = this;
      this.email = $("#email").val();
      this.password = $("#pass").val();
      let authenticationData = {
        Username: this.email,
        Password: this.password,
      };
      var authenticationDetails = new AmazonCognitoIdentity.AuthenticationDetails(
        authenticationData
      );

      var poolData = {
        UserPoolId: "us-east-1_KPh2ycnq4", // Your user pool id here
        ClientId: "1qe6ml4g9dh4c1sl5j99k8965j", // Your client id here
      };
      var userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
      var userData = {
        Username: this.email,
        Pool: userPool,
      };
      var cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);
      cognitoUser.authenticateUser(authenticationDetails, {
        newPasswordRequired: function(userAttributes, requiredAttributes) {
          console.log("newPasswordRequired");
        },
        onSuccess: function(result) {
          // console.log('Name + ' + result.idToken.payload.name);
          // console.log('ID token + ' + result.idToken.jwtToken);

          vm.showRequestAccess = false;
          let jsonData = {
            name: result.idToken.payload.name,
            idToken: result.idToken.jwtToken,
            username: vm.email,
          };
          //
          console.log("congitouser", cognitoUser);

          jsonData = JSON.stringify(jsonData);

          let loginDate = new Date();
          loginDate = loginDate.toDateString();

          window.localStorage.setItem("session", jsonData);
          window.localStorage.setItem("loginDate", loginDate);

          window.sessionStorage.setItem("session", jsonData);
          window.sessionStorage.setItem("loginDate", loginDate);
          let isdetail = localStorage.getItem("release:releasepath");
          if (isdetail == "" || isdetail == null || isdetail == "/") {
            vm.$router.push("/accounts");
            window.localStorage.setItem("release:releasepath", "");
          } else {
            vm.$router.push(isdetail);
          }
        },
        onFailure: function(err) {
          vm.errorMessage = err.message;
          vm.showError = true;
        },
      });
      return false;
    },
  },
};
</script>

<style lang="scss">
.background_container_mobile {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .page_header_login {
    background-color: #ffffff;
    display: flex;
    justify-content: space-around;
    margin-bottom:-1px;
    img {
      max-height: 98px;
      height: 100%;
    }
  }
  .login_form_mobile {
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    height: 100%;
    align-items: center;
    div {
      display: flex;
      align-items: flex-end;
    }
    p {
      display: flex;
      align-items: flex-end;
    }
    .form-group {
      width: calc(100% - 56px);
      max-width: 333px;
    }
  }

  .login_footer {
    background-color: #115e67;
    height: 84px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
